import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, Component, useRef } from "react"
import classnames from "classnames"
import { Link } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane
} from "reactstrap"

import TableComponent from "./Components/TableComponent"

const IndexView = (props) => {
    const activeRef = useRef();
    const inactiveRef = useRef();

    const reloadInactiveRef = () => inactiveRef.current.setTokenAPI()

    return (
        <Fragment>
            <Container fluid>
                <Card>
                    <CardBody>
                        <div className="float-end">
                        {
                            (accessRole('create')) ?
                                <Link to="?create">
                                    <Button color="primary">Buat Pengajuan Dokumen</Button>
                                </Link>
                            : null
                        }
                        </div>
                        <CardTitle>Pengajuan Dokumen</CardTitle>
                        <CardSubtitle className="mb-3">
                            {/* Daftar Urut Kepangkatan */}
                        </CardSubtitle>
                        <hr/>
                        <TableComponent ref={inactiveRef} handleInactiveSuccess={reloadInactiveRef}/>
                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    )
}


export default IndexView